import { IconLoader2 } from '@tabler/icons-react'
import { useAppDispatch } from '../../reducers/store'
import { DevicePolicy } from '../../types/SettingsType'
import { deleteDevicePolicy, fetchDevicePolicies } from '../../reducers/settings'
import { fetchAllTravelPolicies } from '../../reducers/travel'
import toast from 'react-hot-toast'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'

interface IDeletePolicyModalProps {
  setShowDeletePolicyModal: (show: boolean) => void
  policyToAction: DevicePolicy | undefined
  setPolicyToAction: (policy: DevicePolicy | undefined) => void
}

function DeletePolicyModal(props: IDeletePolicyModalProps) {
  const { setShowDeletePolicyModal, policyToAction, setPolicyToAction } = props
  const di = useAppDispatch()

  const deletePolicy = async () => {
    const deleted = await di(deleteDevicePolicy(policyToAction!.policyId!))
    if (deleted) {
      toast.success('Policy deleted successfully', DEFAULT_TOAST_CONFIG)
      setPolicyToAction(undefined)
      di(fetchDevicePolicies())
      di(fetchAllTravelPolicies())
      setShowDeletePolicyModal(false)
    } else {
      toast.error('Failed to delete policy', DEFAULT_TOAST_CONFIG)
    }
  }

  return (
    <div
      className="bg-black bg-opacity-50 absolute top-0 left-0 w-full h-full z-50"
      onClick={() => setShowDeletePolicyModal(false)}
    >
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-modalBackground rounded-lg p-6 max-h-[50%] overflow-y-auto border dark:border-gray-600 min-w-[400px] min-h-[182px]"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold mb-4">Delete Policy</h2>
        {policyToAction !== undefined && (
          <>
            <p>
              Are you sure you want to delete the policy. This may
              <br />
              reinstate access for devices that are currently blocked.
              <br />
              This action can not be undone
            </p>

            <div className="flex justify-end mt-6">
              <button
                className="px-4 py-2 mr-2 bg-gray-300 rounded-lg text-neutral-12"
                onClick={() => setShowDeletePolicyModal(false)}
                type="button"
              >
                Cancel
              </button>
              <button className={`px-4 py-2 bg-Red-9 text-white rounded-lg`} onClick={() => deletePolicy()}>
                Delete
              </button>
            </div>
          </>
        )}
        {policyToAction === undefined && (
          <div className="flex items-center justify-center">
            <IconLoader2 size={64} />
          </div>
        )}
      </div>
    </div>
  )
}

export default DeletePolicyModal
